import React, { useEffect, useState } from 'react'
import { SemanticTRANSITIONS, Transition, TransitionPropDuration } from 'semantic-ui-react'
import { useStateFromProp } from '../../hooks/useStateFromProps'

interface Props {
  visible: boolean
  animation: SemanticTRANSITIONS
  duration: TransitionPropDuration
  children: React.ReactNode
  disableClickOutside?: boolean
  notificationSidebar?: boolean
  clickOutside?: () => void
}

const TransitionModalComponent = (props: Props): JSX.Element => {
  const { visible, animation, duration, children, disableClickOutside, notificationSidebar, clickOutside } = props
  const [visibleState, setVisibleState] = useState(visible)
  const [_disableClickOutside, setDisableClickOutside] = useStateFromProp(disableClickOutside ?? false)

  useEffect(() => {
    if (visibleState) {
      const onClickOutside = (e: MouseEvent) => {
        if (!_disableClickOutside && clickOutside) {
          const element = e.target as HTMLElement
          if (notificationSidebar) {
            const modalWidth = 618
            const menuBar = 100
            if ((menuBar + modalWidth) < e.clientX) {
              clickOutside()
            }
          } else {
            const modalWidth = 546
            const calc = (window.innerWidth - (window.innerWidth - modalWidth))
            const _x = e.clientX > 0 ? e.clientX : element.parentElement?.getBoundingClientRect().x ?? 0
            if ((window.innerWidth - _x) > calc) {
              if (element.id !== 'disableCloseModal') {
                clickOutside()
              }
            } else if (element.id === 'closeModal') {
              clickOutside()
            }
          }
        }
      }
      window.addEventListener('mousedown', onClickOutside)
      return () => {
        window.removeEventListener('mousedown', onClickOutside)
      }
    }
  }, [_disableClickOutside, clickOutside, notificationSidebar, visibleState])

  useEffect(() => {
    if (disableClickOutside) {
      setDisableClickOutside(disableClickOutside)
    }
  }, [disableClickOutside, setDisableClickOutside])

  useEffect(() => {
    setVisibleState(visible)
  }, [visible])

  return (
    <Transition
      transitionOnMount={true}
      animation={animation}
      duration={duration}
      children={children}
      visible={visibleState}
    />
  )
}

export default TransitionModalComponent
